<template>
	<div>
		<div v-if="loggedInEmployee.isAdmin">
			<v-card class="mb-4">
				<core-values-list :core-values="coreValues" :reordering="isReordering" @onSortOrderUpdated="onSortOrderUpdated" @onEditCoreValue="onEditCoreValue" @onDeleteCoreValue="onDeleteCoreValue"> </core-values-list>

				<core-value-editor :dialog="coreValueEditorDialog" :title="coreValueEditorTitle" :core-value="editedCoreValue" @save="saveCoreValue" @closeEditor="coreValueEditorDialog = false"> </core-value-editor>
			</v-card>

			<v-footer color="" app height="55">
				<v-spacer></v-spacer>
				<footer-add-btn @click="onAddCoreValue">Add Core Value</footer-add-btn>
			</v-footer>
		</div>
		<div v-else>You do not have access</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	import CoreValuesList from '@/components/CoreValuesList';
	import CoreValueEditor from '@/components/CoreValueEditor';

	export default {
		components: {
			CoreValuesList,
			CoreValueEditor
		},
		data() {
			return {
				coreValueEditorDialog: false,
				editedCoreValueIndex: -1,
				editedCoreValue: undefined,
				isReordering: false
			};
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Core Values');
		},
		computed: {
			...mapGetters({
				coreValues: 'coreValues/coreValues',
				loggedInEmployee: 'loggedInEmployee'
			}),
			coreValueEditorTitle() {
				return this.editedCoreValueIndex === -1 ? 'New Core Value' : 'Edit Core Value';
			}
		},
		methods: {
			async onSortOrderUpdated(coreValues) {
				if (this.isReordering) {
					return;
				}

				this.isReordering = true;

				try {
					await this.$store.dispatch('coreValues/reorder', coreValues.map(x => x.id));
				} catch (error) {
					console.error('Error reordering Core Values');

					try {
						await this.$store.dispatch('coreValues/get');
					} catch (refreshError) {
						console.error('Error refreshing Core Values after reorder failure');
					}
				} finally {
					this.isReordering = false;
				}
			},
			onEditCoreValue(coreValue) {
				this.editedCoreValueIndex = this.coreValues.indexOf(coreValue);
				this.editedCoreValue = Object.assign({}, coreValue);
				this.coreValueEditorDialog = true;
			},
			onDeleteCoreValue(coreValue) {
				const index = this.coreValues.indexOf(coreValue);
				if (confirm('Are you sure you want to delete this Core Value?')) {
					this.$store.dispatch('coreValues/delete', coreValue).then(
						(response) => {},
						(error) => {
							console.error('Error deleting Core Value');
						}
					);
				}
			},
			onAddCoreValue() {
				this.editedCoreValueIndex = -1;
				this.editedCoreValue = undefined;
				this.coreValueEditorDialog = true;
			},
			saveCoreValue(coreValue) {
				if (this.editedCoreValueIndex > -1) {
					this.$store.dispatch('coreValues/edit', coreValue).then(
						(response) => {},
						(error) => {
							console.error('Error saving Core Value');
						}
					);
				} else {
					this.$store.dispatch('coreValues/add', coreValue).then(
						(response) => {},
						(error) => {
							console.error('Error saving Core Value');
						}
					);
				}
			}
		}
	};
</script>

<style></style>
